import { clearAuthToken } from "../../tokenHandler";
export const checkTokenExpiration = (tokenTime) => {
    const currentTime = new Date();
    const tokenExpirationTime = new Date(tokenTime);

    if (tokenExpirationTime < currentTime) {
        clearAuthToken();
    }
    else {
        const timeDifference = tokenExpirationTime - currentTime;
        const minutesRemaining = Math.ceil(timeDifference / (1000 * 60));
        console.log(`Token expires in ${minutesRemaining} minutes`);
    }
};
